import React from 'react';

export const ErrorPage = () => {
    return (
        <div className="parent">
            <div className="error-holder">Error authenticating user. Please try again.</div>
        </div>
    )
}; 